function valueItemisationItemMapper(item) {
  const { buttonType, buttonLabel, buttonUrl, ...rest } = item;

  switch (buttonType) {
    case 'link':
      return {
        cta: {
          linkButton: {
            label: buttonLabel,
            url: buttonUrl,
            target: '_blank',
            authorizationRequired: false,
          },
        },
        ...rest,
      };
    case 'uploader':
      return {
        cta: {
          uploaderButton: {
            label: buttonLabel,
            queryParam: buttonUrl,
          },
        },
        ...rest,
      };
    default:
      return rest;
  }
}

export default function valueItemisationMapper(componentsData) {
  const { items } = componentsData;

  return {
    ...componentsData,
    items: items.map(valueItemisationItemMapper),
  };
}
